import * as React from 'react';
import { Typography } from 'omakase';
import { isNumber, isString, take } from 'es-toolkit/compat';
import LinkButton from '@tock/shared/components/buttons/LinkButton';
import Subheader from 'components/profile/Subheader';
import clsx from 'clsx';

interface Props {
  className?: string;
  itemClassName?: string;
  limit?: number;
  list?: Array<string | number | React.ReactNode>;
  title?: React.ReactNode;
}

const ExpandableList = ({ limit = 5, list, itemClassName, className, title }: Props) => {
  const [isLimited, setIsLimited] = React.useState(true);
  if (!title && !list) {
    return null;
  }

  const toggleIsLimited = () => {
    setIsLimited(!isLimited);
  };

  const listClass = clsx('ExpandableList', className);
  const itemClass = clsx('ExpandableList--item', itemClassName);

  const displayList = isLimited ? take(list, limit) : list;
  return (
    <div className={listClass}>
      {title && <Subheader text={title} mb={1.5} />}
      {displayList && (
        <ul>
          {displayList.map((item, index) => {
            return (
              <li key={`expandableList-${title}-${index}`} className={itemClass}>
                {isString(item) || isNumber(item) ? (
                  <Typography component="span" variant="body02">
                    {item}
                  </Typography>
                ) : (
                  item
                )}
              </li>
            );
          })}
        </ul>
      )}
      {list && list.length > limit && (
        <LinkButton className="ExpandableList--action" onClick={toggleIsLimited}>
          <Typography component="span" variant="caption" color="fgPrimaryBase">
            {isLimited ? 'See all' : 'See less'}
          </Typography>
        </LinkButton>
      )}
    </div>
  );
};

export default ExpandableList;
